module.exports = __webpack_public_path__ + "static/media/mob-screen-circle.dcb258d1.png";